import api from "../index";

export const bookDemoListApi = () => api.post("book-demo-list");
